import { getSearchPath, getQ } from '@zoopla/listing-search/filters/modal';
import { formatIdentifier } from '@zoopla/listing-search-utils';
import { NextRouter } from 'next/router';

export const getIdentifier = (query: NextRouter['query']) =>
    formatIdentifier(getSearchPath(query));
export const getLocation = (query: NextRouter['query']) => {
    const q = getQ(query);
    const coercedQ = Array.isArray(q) ? q[0] : q;
    if (coercedQ !== '') return coercedQ;
    return;
};
